import PremissasMaoDeObraView from "../../components/gestaoOrcamentaria/PremissasMaoDeObraView";

export default function PremissasMaoDeObra() {
  return <PremissasMaoDeObraView />;
}
